module.exports = new __parcel__URL__("shieldwall.42e62331.png").toString();